/**
 * Module: Course Catalog
 * Vue-powered interactive course table
 *
 * @package mg-umbc-course-retriever
 */

import $ from 'jquery';
import * as Vue from 'vue';
import courseTable from './vue-components/course-table.vue';

const daySorter = {
    "M": 1,
    "T": 2,
    "W": 3,
    "TH": 4,
    "F": 5,
}

const timeSorter = {
    "Morning": 1,
    "Afternoon": 2,
    "Evening": 3
}
function init() {
    let mountElement = document.querySelector('.course-table');
    if (mountElement) {
        let tableRows = mountElement.querySelectorAll('.course-table table tbody tr');
        let tableHeadings = mountElement.querySelectorAll('.course-table table th');
        if (tableRows && tableRows.length && tableHeadings && tableHeadings.length) {
            let courseObject = returnStructuredCourseObject(tableRows, tableHeadings);
            mountElement.innerHTML = '';
            let intitialSearchString = returnInitialSearchString();
            let app = Vue.createApp({
                el: mountElement,
                data: function() {
                    return {
                        filters: courseObject.filters,
                        courses: courseObject.courses,
                        searchString: intitialSearchString
                    }
                },
                components: {
                    courseTable: courseTable
                },
                template: `<course-table
                    :searchString="searchString"
                    :filters="filters"
                    :courses="courses">
                    </course-table>`
            });
            let mounted = app.mount(mountElement);
        }
    }
}

function returnInitialSearchString() {
    let stringToReturn = '';
    let queryString = window.location.search;
    if (queryString) {
        let urlParams = new URLSearchParams(queryString);
        let searchParam = urlParams.get('course-search');
        if (searchParam) {
            stringToReturn = searchParam.trim();
        }
    }
    return stringToReturn;
}

function returnStructuredCourseObject(tableRows, tableHeadings) {
    let objectToReturn = {
        courses: [],
        filters: {}
    };
    for (let i = 0; i < tableRows.length; i++) {
        let theseCells = tableRows[i].querySelectorAll('td');
        let thisCourse = {
            'Subject': theseCells[0].innerHTML.trim(),
            catalogNumber: theseCells[1].innerHTML.trim(),
            title: theseCells[2].innerHTML.trim(),
            url: theseCells[3].textContent.trim(),
            'Format': theseCells[4].innerHTML.trim().split(', '),
            'Location': theseCells[5].innerHTML.trim(),
            'Times': theseCells[6].innerHTML.trim().split(', '),
            'GEP': theseCells[7].innerHTML.trim().split(', '),
            'Session': theseCells[8].innerHTML.trim().split(', '),
            'Start Time': theseCells[9].innerHTML.trim(),
            'End Time': theseCells[10].innerHTML.trim(),
            'Days': theseCells[11].innerHTML.trim().split(', '),
        };
        objectToReturn.courses.push(thisCourse);
    }
    objectToReturn.filters = collectUniqueFilterKeys(objectToReturn.courses);
    objectToReturn.courses = objectToReturn.courses.sort(courseSort);
    return objectToReturn;
}

function courseSort(ob1,ob2) {
    if (ob1['Subject'] > ob2['Subject']) {
        return 1;
    } else if (ob1['Subject'] < ob2['Subject']) {
        return -1;
    }
    if (ob1.catalogNumber < ob2.catalogNumber) {
        return -1;
    } else if (ob1.catalogNumber > ob2.catalogNumber) {
        return 1
    } else {
        return 0;
    }
}

function collectUniqueFilterKeys(courseArray) {
    let filterObject = {};
    for (let i = 0; i < courseArray.length; i++) {
        for (let j in courseArray[i]) {
            if (j !== 'url' && j !== 'title' && j !== 'catalogNumber' && j !== 'Subject') {
                if (!filterObject[j]) {
                    filterObject[j] = [];
                }
                let filterItemValues = courseArray[i][j];
                if (Array.isArray(filterItemValues)) {
                    for (let k = 0; k < filterItemValues.length; k++) {
                        if (filterItemValues[k] && !(filterObject[j].includes(filterItemValues[k]))) {
                            filterObject[j].push(filterItemValues[k]);
                        }
                    }
                } else {
                    if (filterItemValues && !(filterObject[j].includes(filterItemValues))) {
                        filterObject[j].push(filterItemValues);
                    }
                }
            }
        }
    }
    let objectToReturn = {};
    for (let key in filterObject) {
        if (key === 'Days') {
            filterObject[key].sort(function sortByDay(a, b) {
                let day1 = a;
                let day2 = b;
                return daySorter[day1] - daySorter[day2];
            });
        } else if (key === 'Times') {
            filterObject[key].sort(function sortByTime(a, b) {
                let time1 = a;
                let time2 = b;
                return timeSorter[time1] - timeSorter[time2];
            });
        } else {
            filterObject[key].sort();
        }
        objectToReturn[key] = [];
        for (let i = 0; i < filterObject[key].length; i++) {
            objectToReturn[key].push({
                value: filterObject[key][i],
                isChecked: false
            });
        }
    }
    return objectToReturn;
}

$(document).ready(function() {
    init();
});